export enum ViewLayout {
  // Left description panel, visible on desktop mode
  Column = 'column',

  // Left description panel, visible on desktop mode
  ColumnToggle = 'column-toggle',
    
  // Bottom description panel, visible at 960 below
  Drawer = 'drawer',
  
  // tool bar button in menu
  Tools = 'tools',

  // Interaction tools, visible in drawer when responsive, floating on the scene in desktop
  Toolbar = 'toolbar',
  
  // Camera controls - zoom, pan, reset
  Camera = 'camera',
  
  // Play, pause, scrubber
  Media = 'media',

  // Free floating play, pause, scrubber
  Mediabar = 'mediabar',

  // Free floating play, pause, scrubber, chapter navigation
  // Used by medium / small
  Navbar = 'mediabar',

  // reset button
  Reset = 'reset',

  // audio controls
  Audio = 'audio',
  
  // White menu button and child items, visible at 960 below
  Menu = 'menu',
  
  // Pagination bar, visible when drawer is swiped up and other places
  Pagination = 'pagination',

  // fullscreen button
  Fullscreen = 'fullscreen',

  // help button
  Help = 'help',

  // content description
  Description = 'description',

  // wikipedia descriptions
  NodeInfo = 'nodeInfo',

  // search (anatomy tree) button
  Search = 'search',

  // presenter button
  Presenter = 'presenter',
  
  // BioDigital logo
  Logo = 'logo',

  LabelList = 'labelList',

  ChapterList = 'chapterList'
}
